import React from 'react';
import './HomeCourses.css';
import { FaLandmark, FaUsers, FaGlobeAsia, FaFeatherAlt, FaBook } from 'react-icons/fa';

function HomeCourses() {
  const subjects = [
    { id: 1, name: 'History', icon: <FaLandmark />, color: '#3b82f6' },
    { id: 2, name: 'Political Science', icon: <FaUsers />, color: '#8b5cf6' },
    { id: 3, name: 'Sociology', icon: <FaUsers />, color: '#ec4899' },
    { id: 4, name: 'Hindi Literature', icon: <FaFeatherAlt />, color: '#f59e0b' },
    { id: 5, name: 'Geography', icon: <FaGlobeAsia />, color: '#10b981' },
  ];

  return (
    <section className="home-courses-layout-section">
      <div className="home-courses-layout-container">
        
        <div className="home-courses-layout-header">
          <h2>Bachelor of Arts (B.A.)</h2>
          <p>Explore diverse subjects and build a strong foundation for your future career</p>
        </div>

        <div className="home-courses-subjects-grid">
          {subjects.map((subject) => (
            <div key={subject.id} className="subject-card">
              <div className="subject-icon" style={{ background: subject.color }}>
                {subject.icon}
              </div>
              <h3>{subject.name}</h3>
            </div>
          ))}
        </div>

        <div className="home-courses-info">
          <div className="info-item">
            <FaBook className="info-icon" />
            <div>
              <h4>Duration</h4>
              <p>3 Years</p>
            </div>
          </div>
          <div className="info-item">
            <FaBook className="info-icon" />
            <div>
              <h4>Eligibility</h4>
              <p>10+2 Pass</p>
            </div>
          </div>
          <div className="info-item">
            <FaBook className="info-icon" />
            <div>
              <h4>Recognition</h4>
              <p>UGC Approved</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}

export default HomeCourses;